import { useEffect } from 'react';
import { useA11y } from '../hooks/useA11y.js';
import { KEY_MAP, matchesKey } from '../utils/keyMap.js';
import { TEXT_SIZES } from '../a11y.types.js';

export function useGlobalShortcuts({ onHelp, onSkipToMain } = {}) {
  const a11y = useA11y();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handler = (e) => {
      if (matchesKey(e, KEY_MAP.SKIP_TO_MAIN)) {
        e.preventDefault();
        if (typeof onSkipToMain === 'function') onSkipToMain();
        return;
      }
      if (matchesKey(e, KEY_MAP.HELP)) {
        e.preventDefault();
        if (typeof onHelp === 'function') onHelp();
        return;
      }
      if (matchesKey(e, KEY_MAP.TOGGLE_FOCUS)) {
        e.preventDefault();
        a11y.toggle('highlightFocus');
        return;
      }
      if (matchesKey(e, KEY_MAP.PAUSE_ANIM)) {
        e.preventDefault();
        a11y.toggle('pauseAnimations');
        return;
      }
      if (matchesKey(e, KEY_MAP.RESET_ALL)) {
        e.preventDefault();
        a11y.reset();
        return;
      }
      if (matchesKey(e, KEY_MAP.INCREASE_TEXT)) {
        e.preventDefault();
        const i = TEXT_SIZES.indexOf(a11y.settings.textSize);
        const next = TEXT_SIZES[Math.min(TEXT_SIZES.length - 1, i + 1)];
        a11y.set('textSize', next);
        return;
      }
      if (matchesKey(e, KEY_MAP.DECREASE_TEXT)) {
        e.preventDefault();
        const i = TEXT_SIZES.indexOf(a11y.settings.textSize);
        const next = TEXT_SIZES[Math.max(0, i - 1)];
        a11y.set('textSize', next);
        return;
      }
      if (matchesKey(e, KEY_MAP.RESET_TEXT)) {
        e.preventDefault();
        a11y.set('textSize', 100);
        return;
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [a11y, onHelp, onSkipToMain]);
}
